
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
export default {
  mixins: [eventTrackingMixins],
  props: {
    compactViewOnly: {
      type: Boolean,
      default: false,
    },
    mobileViewOnly: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => { },
    },
    company: {
      type: Object,
      default: () => { },
    },
    dataProductName : {
      type: String,
      default: '',
    },
    dataProductCategory : {
      type: String,
      default: '',
    },
    dataInsurerCompany : {
      type: String,
      default: '',
    },
    dataInsurerCode : {
      type: String,
      default: '',
    },
  },

  async mounted() {
    await this.$nextTick();
    // console.log('mounted() sponsoredPromotion')
    // console.log(`this.$refs["sponsored-promotion-item"]...`)
    // console.log(this.$refs["sponsored-promotion-item"])

    // this.handleEventTracking_promotionBannerLoaded()
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  updated() {
    // console.info('beforeRouteUpdate ... 0 updated...')
    // this.handleEventTracking_promotionBannerLoaded()
    // console.info('beforeRouteUpdate ... 1 updated...')
  },

  methods: {
    openPopUp() {
      this.$bvModal.show(this.data.scenarioId + '_' + this.data.promotionId);
      this.handleEventTracking()
    },

    handleEventTracking(){
        const eventTrackingParams = this.initEventTrackingParams()

        eventTrackingParams.a = 'ad_impression' 
        eventTrackingParams.c = 'promo_details' 
        eventTrackingParams.l = this.data.scenarioId 
        eventTrackingParams.cd.insurer_name = this.dataInsurerCompany
        eventTrackingParams.cd.product_name = this.dataProductName
        eventTrackingParams.cd.product_category = this.dataProductCategory
        
        this.sendEventTracking(eventTrackingParams)
      }


  },
};
